module.exports = __webpack_public_path__ + "img/hr-puberty-decal-08.90166dc7.png";